export default {
  data () {
    return {
      autocomplete: [],
      lazySelect: {}
    }
  },
  created () {
    for (let { model, value, search, fetchSelected = true } of this.autocomplete) {
      // add model data
      this.lazySelect = {
        ...this.lazySelect,
        [model]: {
          selectedIds: [],
          searchColumns: search || ['name'], // [ column, [ model, column ] ]
          listItems: [],
          selectedItems: [],
          search: null,
          loading: false,
          fetchSelected
        }
      }
      // add watcher for value
      this.$watch(
        () => {
          return value.split('.').reduce((root, prop) => root[prop], this)
        },
        (value) => {
          this.lazySelect[model].selectedIds = Array.isArray(value) ? value : value ? [value] : []
        }
      ),
      // add watcher for selected item
      this.$watch(
        () => this.lazySelect[model].selectedIds,
        (next, prev) => {
          if (prev.length === next.length) {
            return // this prevents duplicit request
          }
          this.updateLazySelect({ model })
        },
        {
          deep: true
        }
      )
      // add watcher for search input
      this.$watch(
        () => this.lazySelect[model].search,
        (next, prev) => {
          let { selectedItems, searchProp } = this.lazySelect[model]
          let skipSearch = selectedItems.some(item => item[searchProp] === next) || (next && !prev)
          if (skipSearch || next === null) {
            return
          }
          setTimeout(() => this.updateLazySelect({ model, forceSearch: next !== prev }), 500)
        }
      )
    }
  },
  methods: {
    async updateLazySelect ({ model, forceSearch = false }) {
      try {
        this.lazySelect[model].loading = true
        this.lazySelect[model].listItems = await this.fetchLazyItems({ model, forceSearch })
      } catch (error) {
        console.error('[lazyItems][updateLazySelect]', error)
      } finally {
        this.lazySelect[model].loading = false
      }
    },
    async fetchLazyItems ({ model, forceSearch }) {
      try {
        const { search, selectedIds, searchColumns, fetchSelected } = this.lazySelect[model]
        const params = {
          limit: selectedIds.length
        }

        if (search && (forceSearch || !selectedIds.length)) {
          params.search = [...searchColumns].map(column => {
            if (Array.isArray(column)) {
              let [model, prop] = column
              return `${model}.${prop}+${search}`
            }
            return `${model}.${column}+${search}`
          }).join()
          params.searchMode = 'OR'
        }

        const { items, total } = await this.$store.dispatch('lazyItems/getItems', {
          model,
          params,
          save: false
        })

        if (selectedIds.length && fetchSelected) {
          const selected = await this.fetchSelectedItems({ ids: selectedIds, model })
          for (let item of selected) {
            items.unshift(item)
          }
        }

        if (total > items.length) {
          return Promise.resolve([...items, { id: 0, name: this.$t('showing-n-of-m', [items.length, total]), disabled: true }])
        } else {
          return Promise.resolve([...items])
        }
      } catch (error) {
        return Promise.reject(error)
      }
    },
    async fetchSelectedItems ({ ids, model }) {
      const { listItems, selectedItems } = this.lazySelect[model]
      const items = []
      for (let id of ids) {
        let selected = selectedItems.filter(item => item.id === id).shift() || listItems.filter(item => item.id === id).shift()
        if (!selected) {
          selected = await this.$store.dispatch('lazyItems/getItem', { id, model })
        }
        items.push(selected)
      }

      this.lazySelect[model].selectedItems = items
      return Promise.resolve(items)
    }
  }
}
